module.exports = {
	"ff_all_asset": 44842412573,
	"oil_majors": [
		9497491610,
		0.21179707034136075,
		[
			[
				"Exxon Mobil",
				3681731715
			],
			[
				"Chevron",
				1988407058
			],
			[
				"Shell",
				1014467554
			],
			[
				"ConocoPhillips",
				952929766
			],
			[
				"TotalEnergies",
				634748139
			],
			[
				"BP",
				414597056
			],
			[
				"Phillips 66",
				362647633
			],
			[
				"Valero Energy",
				297318521
			],
			[
				"Eni",
				150644168
			]
		]
	],
	"og": [
		19251282520,
		0.4293096962314503,
		[
			[
				"Exxon Mobil",
				3681731715
			],
			[
				"Chevron",
				1988407058
			],
			[
				"Shell",
				1014467554
			],
			[
				"ConocoPhillips",
				952929766
			],
			[
				"Cheniere Energy",
				706506900
			],
			[
				"TotalEnergies",
				634748139
			],
			[
				"Williams Companies",
				518067092
			],
			[
				"EOG Resources",
				512936904
			],
			[
				"Expand Energy",
				452805591
			],
			[
				"ONEOK",
				437770115
			]
		]
	],
	"ut": [
		11975994897,
		0.26706847847456916,
		[
			[
				"NextEra Energy",
				1036721017
			],
			[
				"Southern",
				716471336
			],
			[
				"Duke Energy",
				673106508
			],
			[
				"GE Vernova",
				599068248
			],
			[
				"Constellation Energy",
				448624314
			],
			[
				"American Electric Power",
				414066211
			],
			[
				"Dominion Energy",
				334960620
			],
			[
				"Exelon",
				329437418
			],
			[
				"Sempra",
				321426038
			],
			[
				"Enel",
				300920866
			]
		]
	],
	"other": [
		13615135156,
		0.3036218252939805,
		[
			[
				"Berkshire Hathaway",
				6942459613
			],
			[
				"Siemens",
				794767767
			],
			[
				"Blackstone",
				727577854
			],
			[
				"KKR",
				555038055
			],
			[
				"BHP Group",
				551287744
			],
			[
				"Ares Management",
				439529171
			],
			[
				"CSX",
				403613461
			],
			[
				"Mitsubishi",
				274356904
			],
			[
				"ITOCHU",
				250613573
			],
			[
				"Mitsubishi Heavy Indus",
				247337910
			]
		]
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/data/TspHoldingStats.json
// module id = 1013
// module chunks = 0